import { connect } from 'react-redux';
import { withReferralDetails } from 'src/_shared/api/components/referrals/';
import { withGetCompanyData } from 'src/_shared/api/components/settings/';
import { dashboardActions, manageJobsActions } from 'src/actions.js';
import { compose } from '../_shared/services/utils';
import ReferralDetailsComponent from './ReferralDetailsComponent.jsx';

const mapStateToProperties = (state) => {
	const { currentUser } = state.user;
	const { allMultiLingualData } = state.dashboard;
	return {
		id: currentUser.id,
		currentUser,
		allMultiLingualData,
		companyId: currentUser.companyId,
	};
};

const mapDispatchToProperties = (dispatch) => {
	return {
		setCurrentCurrencyRate(currencyRate) {
			dispatch(manageJobsActions.setCurrentCurrencyRate(currencyRate));
		},
		setCurrentCurrencySymbol(currencySymbol) {
			dispatch(manageJobsActions.setCurrentCurrencySymbol(currencySymbol));
		},
		setMultiLingualData(data) {
			dispatch(dashboardActions.createSetMultiLingualData(data));
		},
	};
};

const ReferralDetailsWithAPI = compose(
	withReferralDetails,
	withGetCompanyData
)(ReferralDetailsComponent);

export const ReferralDetails = connect(
	mapStateToProperties,
	mapDispatchToProperties
)(ReferralDetailsWithAPI);
